export default "__VITE_ASSET__086d27bb__"